<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <FinancialVehicleForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import FinancialVehicleForm from '@/components/settings/financial/vehicle/FinancialVehicleForm'

export default {
  name: 'FinancialVehicleAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    FinancialVehicleForm
  }
}
</script>
